/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {BetDetailsPage} from "../betDetails/betDetails";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";

//和投注历史的样式相同
@Component({
    templateUrl: 'agencyUserZbList.html',
    selector: 'agency-user-zb-list-page',
})
export class AgencyUserZbListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    requestData: any;

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController,
                private loadingCtrl: LoadingController) {
        this.requestData = navParams.get("requestData");
        this.loadingData(navParams.get("data"));
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.agentUserZbSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.loadingData(data);
            }else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
            if (refresher) {
                refresher.complete();
                this.infiniteScrollBoolean = true;
            }
        });
    }

    doInfinite(infiniteScroll) {
        let dataParams = this.requestData;
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.agentUserZbSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    data["reslist"].map(item => {
                        item["bettime"] = item["opttime"].replace(/-/g, '/');
                        item["betinfo"] = item["wid"].indexOf("B") == 0;
                        return item;
                    });
                    this.recordList = this.recordList.concat(data["reslist"]);
                    this.totalNum = data["totalrecord"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    //更新加工数据
    loadingData(data: any) {
        this.recordList = data["reslist"];
        this.recordList.map(item => {
            item["bettime"] = item["opttime"].replace(/-/g, '/');
            item["betinfo"] = item["wid"].indexOf("B") == 0;
            return item;
        });
        this.totalNum = data["totalrecord"];
    }

    ionViewWillEnter() {
        // this.getFirstData();
    }

    dismiss() {
        this.viewCtrl.dismiss().catch(() => {
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/agencyUserZbList/agencyUserZbList.ts